import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { map, mergeMap } from 'rxjs/operators';
import { MasterDataService } from '../services/masterdata.service';
import { UserRolesService } from '../services/user-roles.service';
import { Router } from '@angular/router';
import { SessionStorageService } from '../core/services/session-storage.service';
@Component({
    selector: 'app-user-role-list',
    templateUrl: './user-role-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserRoleListComponent implements OnInit {
    selectedRole: number;
    userRoleDetails: Array<any> = [];
    @Output() roleChange = new EventEmitter<number>();
    showLoader: boolean = false;
    disableUserRoleList: boolean = false;
    isUserSuperAdmin: boolean = false; 

  constructor(private readonly userRoleService: UserRolesService,
    private  readonly masterDataService: MasterDataService,
    private  readonly router: Router,
    private readonly sessionStorage: SessionStorageService) { }

    ngOnInit() {
        this.showLoader = true;
        /*setTimeout(() => {*/
            this.updateUserRoles();
        /*}, 1000)*/

        this.userRoleService.getDisableUserRoleList().subscribe(res => {
            this.disableUserRoleList = res;
        })
      
        this.userRoleService.getUserRoleList().subscribe(res => {
            this.userRoleDetails = res;
        })
    }

    updateUserRoles() {
        this.userRoleService.getUserRoles().pipe(
            map((res: any) => {
                if (res) {
                    const roles = [].concat(res.Roleid);
                    const HighestRoleId = this.sessionStorage.getItem('HighestRoleId');
                    const validHighestRoleId = roles.find(item => item === HighestRoleId);
                    if (validHighestRoleId) {
                        this.selectedRole = Number(HighestRoleId);
                    } else {
                        this.selectedRole = res.HighestRoleId;
                    }
                    this.userRoleService.currentRoleId = res.HighestRoleId;
                    this.userRoleService.userRoleId = this.selectedRole;
                    this.userRoleService.assignedCountries = res.AssignedCountries;
                    this.userRoleService.loggedInUserId = res.LoggedInUserId;
                    this.userRoleService.setLoggedInUserID(res.LoggedInUserId);
                    this.userRoleService.setLoggedInUserEmail(res.LoggedInUserEmail);
                    this.userRoleService.setUserRoleList(roles);
                    this.userRoleService.setOmnitureEnvironment(res.OmnitureEnvironment);
                    if (roles.includes(1)) {
                        this.isUserSuperAdmin = true;
                    }                   
                } 
            })
            ).subscribe(() => {
              this.showLoader = false;
              this.roleChange.emit(Number(this.selectedRole));
            });
    }

    updateUserRoleNames(roles) { 
        const userRole = {
            1: 'Admin',
            2: 'Facilitator',
            3: 'Country Admin',
            4: 'Coordinator',
            5: 'GX Facilitator',
            6: 'Subscription Admin'
        };
        this.userRoleDetails = [];
        if (roles && roles.length > 0) {
            roles.map(role => {
                this.userRoleDetails.push({ roleId: role, roleName: userRole[role] })
            })
        }
    }

    onSelectRole(event: Event) {
        const id = (event.target as HTMLInputElement).value;
        if (id) {
              this.sessionStorage.setItem('HighestRoleId',id);
              this.userRoleService.currentRoleId = +id;
              this.userRoleService.updateUserRole(Number(id)).pipe(
                  map(res => {
                      this.userRoleService.userAssignedCountries = res.AssignedCountries ? res.AssignedCountries : [];
                  }),
                  mergeMap(params => this.userRoleService.getUpdatedMasterData())).subscribe(res => {
                      if (res) {
                          this.masterDataService.masterData = res;
                          this.roleChange.emit(Number(id));
                      }
                  });
          }
    }

}
